import { ChamadoEvidenciaService } from '@/features/chamados/services/chamado-evidencia.service'

import EvidenciaCreateDialog from './adicionar.dialog'
import { EvidenceGallery } from './evidence-gallery'

type Props = {
  callId?: number
  isEditable?: boolean
}

export default function Component({ callId, isEditable }: Props) {
  return (
    <EvidenceGallery
      callId={callId}
      isEditable={isEditable}
      queryKey="callEvidenceImage-gallery"
      repository={ChamadoEvidenciaService}
      renderCreateDialog={({ onSuccess }) => (
        <EvidenciaCreateDialog callId={Number(callId)} onSuccess={onSuccess} />
      )}
    />
  )
}
